import React, { useState, useEffect} from "react";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
import axios from 'axios';
import { Navigate } from "react-router-dom";
 



const BulkbroadcastCreate = ()=>{
     const [message, setMessage ] = useState('');
     const [phonebook, setPhonebook ] = useState([]);
     const [senderId, setSenderId] = useState([]);
     const [senderIdId, setSenderIdId] = useState(0);
     const [phonebookId, setPhonebookId] = useState(0);
     const [broadcastTime, setBroadcastTime ] = useState('');
     const [redirect, setRedirect] = useState(false);
     const [page, setPage] = useState(1);

     useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`phonebook?page=${page}`);
            setPhonebook(data.data); 
        }
        )();
    },[page]);

    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`senderId?page=${page}`);
            setSenderId(data.data);
            

        }
        )();
    },[page]);

     const submit = async (e)=>{
         e.preventDefault();
         const {data} = await axios.post('bulkbroadcast', {
            message,
            phonebook_id:parseInt(phonebookId),
            broadcast_time:broadcastTime,
            sender_id_id:parseInt(senderIdId),
        });
        console.log(data);
        setRedirect(true);
     }
    if(redirect){
        return <Navigate to={'/bulkbroadcast'} />
    }
     return (
         <Wrapper pageTitle={"New Bulkbroadcast"}>
            <InnerNav createLink={'/bulkbroadcastCreate'} listLink={'/bulkbroadcast'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >

                <label className="block text-sm">
                    <span className="text-gray-700 dark:text-gray-400">Sender ID </span>
                    <select
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="senderId"
                        onChange = {e => setSenderIdId(e.target.value)} >
                            <option key='0' value='0' >Choose Sender ID</option>

                        {senderId.map((senderId)=>{
                                        return(
                                            <option key={senderId.id} value={senderId.id} >
                                            {senderId.name}
                                            </option>
                                        );
                                    })
                                }

                    </select>
                </label>

                <label className="block text-sm">
                    <span className="text-gray-700 dark:text-gray-400">Phonebook </span>
                    <select
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Phonebook"
                        onChange = {e => setPhonebookId(e.target.value)} >
                            <option key='0' value='0' >Choose Phonebook</option>

                        {phonebook.map((phonebook)=>{
                                        return(
                                            <option key={phonebook.id} value={phonebook.id} >
                                            {phonebook.name}
                                            </option>
                                        );
                                    })
                                }

                    </select>
                </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Message </span>
                        <textarea 
                        className="block w-full  p-2 border mt-1 text-sm border-gray-300 rounded-md  focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Message"
                        onChange = {e => setMessage(e.target.value)} rows="7"></textarea>
                    </label>

                   

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Broadcast Time </span>
                        <input type="datetime-local"
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Broadcasttime"
                        onChange = {e => setBroadcastTime(e.target.value)} />
                    </label>

                    <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                        <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                        onClick={submit}
                        > <FiSave /> <span className="ml-3">Save</span> </button>
                        </label>
                    </div>
                </div>
             </form>
        </Wrapper>
     );
};
export default BulkbroadcastCreate;